import { Injectable } from '@angular/core';
import colorsJsonGreen from '../../../../assets/teiasoft-themes/green.json';
import colorsJsonBlue from '../../../../assets/teiasoft-themes/blue.json';
import colorsJsonSilver from '../../../../assets/teiasoft-themes/silver.json';
import colorsJsonRed from '../../../../assets/teiasoft-themes/red.json';


@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  private themes: Record<string, Record<string, string>> = {
    green: colorsJsonGreen,
    blue: colorsJsonBlue,
    silver: colorsJsonSilver,
    red: colorsJsonRed,
    // Add new themes here, e.g., yellow: colorsJsonYellow
  };

  public loadTheme(theme: any): void {
    const themeVariables = this.themes[theme];
    if (themeVariables) {
      Object.keys(themeVariables).forEach((key) => {
        document.documentElement.style.setProperty(`--${key}`, themeVariables[key]);
      });
    } else {
      console.warn(`Theme ${theme} not found.`);
    }
  }
}
